const e1 = '/bitrix/js/ui/reaction/item/animations/emoji_01.json';
const e2 = '/bitrix/js/ui/reaction/item/animations/emoji_02.json';
const e3 = '/bitrix/js/ui/reaction/item/animations/emoji_03.json';
const e4 = '/bitrix/js/ui/reaction/item/animations/emoji_04.json';
const e5 = '/bitrix/js/ui/reaction/item/animations/emoji_05.json';
const e6 = '/bitrix/js/ui/reaction/item/animations/emoji_06.json';
const e7 = '/bitrix/js/ui/reaction/item/animations/emoji_07.json';
const e8 = '/bitrix/js/ui/reaction/item/animations/emoji_08.json';
const e9 = '/bitrix/js/ui/reaction/item/animations/emoji_09.json';
const e10 = '/bitrix/js/ui/reaction/item/animations/emoji_10.json';
const e11 = '/bitrix/js/ui/reaction/item/animations/emoji_11.json';
const e12 = '/bitrix/js/ui/reaction/item/animations/emoji_12.json';
const e13 = '/bitrix/js/ui/reaction/item/animations/emoji_13.json';
const e14 = '/bitrix/js/ui/reaction/item/animations/emoji_14.json';
const e15 = '/bitrix/js/ui/reaction/item/animations/emoji_15.json';
const e16 = '/bitrix/js/ui/reaction/item/animations/emoji_16.json';
const e17 = '/bitrix/js/ui/reaction/item/animations/emoji_17.json';
const e18 = '/bitrix/js/ui/reaction/item/animations/emoji_18.json';
const e19 = '/bitrix/js/ui/reaction/item/animations/emoji_19.json';
const e20 = '/bitrix/js/ui/reaction/item/animations/emoji_20.json';
const e21 = '/bitrix/js/ui/reaction/item/animations/emoji_21.json';
const e22 = '/bitrix/js/ui/reaction/item/animations/emoji_22.json';
const e23 = '/bitrix/js/ui/reaction/item/animations/emoji_23.json';
const e24 = '/bitrix/js/ui/reaction/item/animations/emoji_24.json';
const e25 = '/bitrix/js/ui/reaction/item/animations/emoji_25.json';
const e26 = '/bitrix/js/ui/reaction/item/animations/emoji_26.json';
const e27 = '/bitrix/js/ui/reaction/item/animations/emoji_27.json';
const e28 = '/bitrix/js/ui/reaction/item/animations/emoji_28.json';
const e29 = '/bitrix/js/ui/reaction/item/animations/emoji_29.json';
const e30 = '/bitrix/js/ui/reaction/item/animations/emoji_30.json';
const e31 = '/bitrix/js/ui/reaction/item/animations/emoji_31.json';
const e32 = '/bitrix/js/ui/reaction/item/animations/emoji_32.json';
const e33 = '/bitrix/js/ui/reaction/item/animations/emoji_33.json';
const e34 = '/bitrix/js/ui/reaction/item/animations/emoji_34.json';
const e35 = '/bitrix/js/ui/reaction/item/animations/emoji_35.json';
const e36 = '/bitrix/js/ui/reaction/item/animations/emoji_36.json';
const e37 = '/bitrix/js/ui/reaction/item/animations/emoji_37.json';
const e38 = '/bitrix/js/ui/reaction/item/animations/emoji_38.json';
const e39 = '/bitrix/js/ui/reaction/item/animations/emoji_39.json';
const e40 = '/bitrix/js/ui/reaction/item/animations/emoji_40.json';
const e41 = '/bitrix/js/ui/reaction/item/animations/emoji_41.json';
const e42 = '/bitrix/js/ui/reaction/item/animations/emoji_42.json';
const e43 = '/bitrix/js/ui/reaction/item/animations/emoji_43.json';
const e44 = '/bitrix/js/ui/reaction/item/animations/emoji_44.json';
const e45 = '/bitrix/js/ui/reaction/item/animations/emoji_45.json';
const e46 = '/bitrix/js/ui/reaction/item/animations/emoji_46.json';
const e47 = '/bitrix/js/ui/reaction/item/animations/emoji_47.json';
const e48 = '/bitrix/js/ui/reaction/item/animations/emoji_48.json';

import { ReactionName } from './reaction-name';

export const LottieAnimation = {
	[ReactionName.like]: e28,
	[ReactionName.faceWithTearsOfJoy]: e5,
	[ReactionName.redHeart]: e25,
	[ReactionName.neutralFace]: e14,
	[ReactionName.fire]: e24,
	[ReactionName.cry]: e8,
	[ReactionName.slightlySmilingFace]: e1,
	[ReactionName.winkingFace]: e2,
	[ReactionName.laugh]: e3,
	[ReactionName.kiss]: e4,
	[ReactionName.wonder]: e6,
	[ReactionName.slightlyFrowningFace]: e7,
	[ReactionName.loudlyCryingFace]: e9,
	[ReactionName.faceWithStuckOutTongue]: e10,
	[ReactionName.faceWithStuckOutTongueAndWinkingEye]: e11,
	[ReactionName.smilingFaceWithSunglasses]: e12,
	[ReactionName.confusedFace]: e13,
	[ReactionName.flushedFace]: e15,
	[ReactionName.thinkingFace]: e16,
	[ReactionName.angry]: e17,
	[ReactionName.smilingFaceWithHorns]: e18,
	[ReactionName.faceWithThermometer]: e19,
	[ReactionName.facepalm]: e20,
	[ReactionName.poo]: e21,
	[ReactionName.flexedBiceps]: e22,
	[ReactionName.clappingHands]: e26,
	[ReactionName.raisedHand]: e27,
	[ReactionName.dislike]: e29,
	[ReactionName.smilingFaceWithHeartEyes]: e30,
	[ReactionName.smilingFaceWithHearts]: e31,
	[ReactionName.pleadingFace]: e32,
	[ReactionName.relievedFace]: e33,
	[ReactionName.foldedHands]: e34,
	[ReactionName.okHand]: e35,
	[ReactionName.signHorns]: e36,
	[ReactionName.loveYouGesture]: e37,
	[ReactionName.clownFace]: e38,
	[ReactionName.partyingFace]: e39,
	[ReactionName.questionMark]: e40,
	[ReactionName.exclamationMark]: e41,
	[ReactionName.lightBulb]: e42,
	[ReactionName.bomb]: e23,
	[ReactionName.eyes]: e43,
	[ReactionName.crossMark]: e44,
	[ReactionName.whiteHeavyCheckMark]: e45,
	[ReactionName.sleepingSymbol]: e46,
	[ReactionName.hundredPoints]: e47,
	[ReactionName.handshake]: e48,
};
